//
//
//
//
//
//

export default {
    name: "customChecker",
    props: {
        isChecked: {
            type: Boolean,
        },
        activeIcon: {
            type: String,
        },
    },
};
